/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon20Solid = forwardRef('ArrowDUturnLeftDownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.25 9a7.25 7.25 0 0 1 14.5 0v4.5a1.25 1.25 0 1 1-2.5 0V9a4.75 4.75 0 1 0-9.5 0v4.754l1.883-2.297a1.25 1.25 0 0 1 1.934 1.586l-3.134 3.82a2.5 2.5 0 0 1-3.866 0l-3.133-3.82a1.25 1.25 0 0 1 1.933-1.586l1.883 2.297V9Z" })));
});
